module.exports = __webpack_public_path__ + "static/media/lord-i-am-not-worthy.d4beee15.txt";